module.exports = __webpack_public_path__ + "img/ali.10741496.png";